import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { useOkapiKy } from "@folio/stripes/core";
import { Pane, Button, MenuSection, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useQuery } from "react-query";
import { fetchLegalPersonById } from "../../api/legalPersonService";
import LegalPersonDetail from "./LegalPersonDetail";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { usePermissions } from "../../hooks/usePermissions";
import { usePersonAuthorityLink } from "../../hooks/usePersonAuthorityLink";
import { PersonAuthorityLinkMenuItems, PersonAuthorityLinkModals, } from "../../components/PersonAuthorityLinkActions";
var LegalPersonDetailPage = function () {
    var id = useParams().id;
    var history = useHistory();
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var canEditLegalPerson = usePermissions().canEditLegalPerson;
    var _a = useQuery(["legalPerson", id], function () { return fetchLegalPersonById(ky, id); }, {
        enabled: !!id,
    }), legalPerson = _a.data, isLoading = _a.isLoading, isError = _a.isError, error = _a.error;
    // Hooks must run before the early returns below; the hook tolerates a missing person.
    var authorityLink = usePersonAuthorityLink({
        kind: "legal",
        person: legalPerson,
        // The hook already stores the returned person in this page's query cache.
        onUpdated: function () { },
        onMerged: function (target) {
            if (target === null || target === void 0 ? void 0 : target.id) {
                history.replace("/bragency/legal-persons/detail/".concat(target.id));
            }
        },
    });
    var handleBackToList = function () {
        history.goBack();
    };
    var handleEdit = function () {
        history.push("/bragency/legal-persons/edit/".concat(id));
    };
    var handleReportChange = function () {
        history.push("/bragency/legal-persons/report-change/".concat(id));
    };
    if (!id) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                    id: "ui-br-agency.legal-person.detail.pane.title",
                }) },
                React.createElement("p", null, formatMessage({ id: "ui-br-agency.legal-person.id.not.provided" })),
                React.createElement(Button, { buttonStyle: "primary", onClick: handleBackToList },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.back" })))));
    }
    if (isLoading) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                    id: "ui-br-agency.legal-person.detail.pane.title",
                }) },
                React.createElement(FormattedMessage, { id: "ui-br-agency.loading" }))));
    }
    if (isError || !legalPerson) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                    id: "ui-br-agency.legal-person.detail.pane.title",
                }) },
                React.createElement("p", null, (error === null || error === void 0 ? void 0 : error.message) ||
                    formatMessage({ id: "ui-br-agency.legal-person.not.found" })),
                React.createElement(Button, { buttonStyle: "primary", onClick: handleBackToList },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.back" })))));
    }
    var displayName = legalPerson.name ||
        formatMessage({ id: "ui-br-agency.legal-person.detail.pane.title" });
    var actionMenu = canEditLegalPerson ||
        authorityLink.canManage ||
        authorityLink.canMergeDuplicates
        ? function (_a) {
            var onToggle = _a.onToggle;
            return (React.createElement(MenuSection, { id: "legal-person-actions" },
                canEditLegalPerson && (React.createElement(React.Fragment, null,
                    React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                            onToggle();
                            handleEdit();
                        } },
                        React.createElement(FormattedMessage, { id: "ui-br-agency.button.edit" })),
                    React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                            onToggle();
                            handleReportChange();
                        } },
                        React.createElement(FormattedMessage, { id: "ui-br-agency.legal-person.button.reportChange" })))),
                React.createElement(PersonAuthorityLinkMenuItems, { link: authorityLink, onToggle: onToggle })));
        }
        : undefined;
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { defaultWidth: "fill", paneTitle: displayName, firstMenu: React.createElement(Button, { buttonStyle: "default", onClick: handleBackToList, marginBottom0: true },
                React.createElement(FormattedMessage, { id: "ui-br-agency.button.back" })), actionMenu: actionMenu },
            React.createElement(PersonAuthorityLinkModals, { link: authorityLink }),
            React.createElement(LegalPersonDetail, { legalPerson: legalPerson }))));
};
export default LegalPersonDetailPage;
